export { default } from './part-input';
